// extracted by mini-css-extract-plugin
export var inputContainer = "_nb-0";